module.exports = __webpack_public_path__ + "static/media/name.143bcaef.svg";